import * as React from 'react';
import { DashboardMenuItem, Menu, MenuItemLink } from 'react-admin';
import Badge from '@material-ui/core/Badge';
import LocalOfferIcon from '@material-ui/icons/LocalOffer';
import FormatListNumberedRtlIcon from '@material-ui/icons/FormatListNumberedRtl';
import HomeWorkIcon from '@material-ui/icons/HomeWork';
import DialpadIcon from '@material-ui/icons/Dialpad';
import SaveIcon from '@material-ui/icons/Save';
import ArticleIcon from '@mui/icons-material/Article';
import SettingsIcon from "@material-ui/icons/Settings";

const CustomMenu = (props) => {
    return (
        <Menu {...props}>
            <br></br>
            <DashboardMenuItem />
            <MenuItemLink to="/product"
                primaryText={
                    <Badge color="primary">
                        Prodotti
                    </Badge>
                }
                leftIcon={<LocalOfferIcon />}
            />
            <MenuItemLink to="/product_type"
                primaryText={
                    <Badge color="primary">
                        Tipologia di prodotto
                    </Badge>
                }
                leftIcon={<FormatListNumberedRtlIcon />}
            />
            <MenuItemLink to="/manufacturer"
            primaryText={
                <Badge color="primary">
                    Produttori
                </Badge>
            }
            leftIcon={<HomeWorkIcon/>}
            />
            <MenuItemLink to="/warranty"
                          primaryText={
                              <Badge color="primary">
                                  Garanzia
                              </Badge>
                          }
                          leftIcon={<SaveIcon/>}
            />
            <MenuItemLink to="/merchandise"
            primaryText={
                <Badge color="primary">
                   Color-Code
                </Badge>
            }
            leftIcon={<DialpadIcon/>}
            />
            <MenuItemLink to="/label"
            primaryText={
                <Badge color="primary">
                   Etichette
                </Badge>
            }
            leftIcon={<ArticleIcon/>}
            />

            <MenuItemLink to="/my-profile"
                          primaryText={
                              <Badge color="primary">
                                 Impostazioni
                              </Badge>
                          }
                          leftIcon={<SettingsIcon/>}
            />
        </Menu>
    );
};
export default CustomMenu;